import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {getOfferDisplayStatus} from "../../../offer/utils/get_offer_display_status";
import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {getPropertyBadgeType} from "../../../property/utils/get_property_badge_type";
import {IPropertyConfiguratorProperty} from "../../../property_configurator/types/IPropertyConfiguratorProperty";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {gtmEventPropertyListClick} from "../../../tracking/google_tag_manager/gtm_event_property_list";
import {getCurrency} from "../../../utils/get_currency";
import {AskForPropertyButton} from "./AskForPropertyButton";
import {PromotionButton} from "./PromotionButton";
import {ReservedButton} from "./ReservedButton";

interface IProps {
    property: IPropertyListApplicationButtonProperty;
    isAutoresponderEnabled: boolean;
    vendorId: number;
    applicationSourceSection?: ApplicationSourceSection;
    isPlansList?: boolean;
    className?: string;
    isInPropertyConfigurator?: boolean;
    onLeadBtnClick?: (property: IPropertyListProperty) => void;
}

type IPropertyListApplicationButtonProperty = IPropertyListProperty | IPropertyConfiguratorProperty;

export const PropertyListApplicationButton = (props: IProps) => {
    const {applicationSourceSection, property, vendorId, isPlansList, isInPropertyConfigurator} = props;

    const applicationSourceSectionData = applicationSourceSection || ApplicationSourceSection.BODY;
    const showPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });
    const propertyBadgeType = getPropertyBadgeType(property);
    const isSaleOverLimit = getOfferDisplayStatus(property.offer) === "limited";

    const onOpen = () => {
        if (property.is_reserved && !isPlansList) {
            gtmEventPropertyListClick("rezerwacja");
        } else if (!property.is_promo) {
            gtmEventPropertyListClick("zapytaj o cene");
        }
    };

    const gtmData: IGTMEventLeadForm = {
        clickText:
            propertyBadgeType ??
            getLeadButtonText({
                isPriceHidden: !showPrice,
                isProperty: !!property.price,
                propertyPrice: property.price,
                isPropertyList: true
            }),
        source: GTMEventApplicationSourceSection.PROPERTY_CONFIGURATOR,
        vendorName: property.offer.vendor.name,
        offerName: property.offer.name
    };

    return (
        <ApplicationModalButtonWithHiddenPrices
            source={getSource(property, isPlansList, isInPropertyConfigurator, showPrice)}
            onOpen={onOpen}
            shouldShowPrice={showPrice}
            gtmData={gtmData}
            render={({handleClick}) => {
                if ((propertyBadgeType === "promotion" || property.is_promo) && !isPlansList) {
                    return <PromotionButton onClick={handleClick} property={property} showPrice={showPrice} />;
                }

                if (propertyBadgeType === "reservation" && !isPlansList) {
                    return <ReservedButton onClick={handleClick} />;
                }

                return (
                    <AskForPropertyButton
                        onClick={() => {
                            handleClick();
                            props.onLeadBtnClick?.(property);
                        }}
                        twoPercentCreditAvailable={property.credit_two_percent}
                        isPlansList={isPlansList}
                        isInPropertyConfigurator={isInPropertyConfigurator}
                        price={property.price}
                        priceType={property.price_type ?? property.offer.price_type}
                        showPrice={showPrice}
                        currency={getCurrency({currency: property.offer.currency})}
                    />
                );
            }}
            sourceSection={applicationSourceSectionData}
            vendorId={vendorId}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={isSaleOverLimit}
        />
    );
};

//  Utils
function getSource(property: IPropertyListApplicationButtonProperty, isPlansList?: boolean, isInPropertyConfigurator?: boolean, showPrice?: boolean) {
    if (showPrice || (property.configuration.show_price && !!property.price)) {
        return ApplicationSource.Property;
    }

    if (isInPropertyConfigurator) {
        return ApplicationSource.PropertyConfigurator;
    }

    if (property.is_promo && !isPlansList) {
        return ApplicationSource.Promotion;
    }

    if (property.is_reserved && !isPlansList) {
        return ApplicationSource.Reservation;
    }

    return ApplicationSource.PriceInquiry;
}
import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {getOfferDisplayStatus} from "../../../offer/utils/get_offer_display_status";
import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {getPropertyBadgeType} from "../../../property/utils/get_property_badge_type";
import {IPropertyConfiguratorProperty} from "../../../property_configurator/types/IPropertyConfiguratorProperty";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {gtmEventPropertyListClick} from "../../../tracking/google_tag_manager/gtm_event_property_list";
import {getCurrency} from "../../../utils/get_currency";
import {AskForPropertyButton} from "./AskForPropertyButton";
import {PromotionButton} from "./PromotionButton";
import {ReservedButton} from "./ReservedButton";

interface IProps {
    property: IPropertyListApplicationButtonProperty;
    isAutoresponderEnabled: boolean;
    vendorId: number;
    applicationSourceSection?: ApplicationSourceSection;
    isPlansList?: boolean;
    className?: string;
    isInPropertyConfigurator?: boolean;
    onLeadBtnClick?: (property: IPropertyListProperty) => void;
}

type IPropertyListApplicationButtonProperty = IPropertyListProperty | IPropertyConfiguratorProperty;

export const PropertyListApplicationButton = (props: IProps) => {
    const {applicationSourceSection, property, vendorId, isPlansList, isInPropertyConfigurator} = props;

    const applicationSourceSectionData = applicationSourceSection || ApplicationSourceSection.BODY;
    const showPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });
    const propertyBadgeType = getPropertyBadgeType(property);
    const isSaleOverLimit = getOfferDisplayStatus(property.offer) === "limited";

    const onOpen = () => {
        if (property.is_reserved && !isPlansList) {
            gtmEventPropertyListClick("rezerwacja");
        } else if (!property.is_promo) {
            gtmEventPropertyListClick("zapytaj o cene");
        }
    };

    const gtmData: IGTMEventLeadForm = {
        clickText:
            propertyBadgeType ??
            getLeadButtonText({
                isPriceHidden: !showPrice,
                isProperty: !!property.price,
                propertyPrice: property.price,
                isPropertyList: true
            }),
        source: GTMEventApplicationSourceSection.PROPERTY_CONFIGURATOR,
        vendorName: property.offer.vendor.name,
        offerName: property.offer.name
    };

    return (
        <ApplicationModalButtonWithHiddenPrices
            source={getSource(property, isPlansList, isInPropertyConfigurator, showPrice)}
            onOpen={onOpen}
            shouldShowPrice={showPrice}
            gtmData={gtmData}
            render={({handleClick}) => {
                if ((propertyBadgeType === "promotion" || property.is_promo) && !isPlansList) {
                    return <PromotionButton onClick={handleClick} property={property} showPrice={showPrice} />;
                }

                if (propertyBadgeType === "reservation" && !isPlansList) {
                    return <ReservedButton onClick={handleClick} />;
                }

                return (
                    <AskForPropertyButton
                        onClick={() => {
                            handleClick();
                            props.onLeadBtnClick?.(property);
                        }}
                        twoPercentCreditAvailable={property.credit_two_percent}
                        isPlansList={isPlansList}
                        isInPropertyConfigurator={isInPropertyConfigurator}
                        price={property.price}
                        priceType={property.price_type ?? property.offer.price_type}
                        showPrice={showPrice}
                        currency={getCurrency({currency: property.offer.currency})}
                    />
                );
            }}
            sourceSection={applicationSourceSectionData}
            vendorId={vendorId}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={isSaleOverLimit}
        />
    );
};

//  Utils
function getSource(property: IPropertyListApplicationButtonProperty, isPlansList?: boolean, isInPropertyConfigurator?: boolean, showPrice?: boolean) {
    if (showPrice || (property.configuration.show_price && !!property.price)) {
        return ApplicationSource.Property;
    }

    if (isInPropertyConfigurator) {
        return ApplicationSource.PropertyConfigurator;
    }

    if (property.is_promo && !isPlansList) {
        return ApplicationSource.Promotion;
    }

    if (property.is_reserved && !isPlansList) {
        return ApplicationSource.Reservation;
    }

    return ApplicationSource.PriceInquiry;
}
